//node_modules
import React, { FunctionComponent } from "react";
import { NextPage } from "next";
import { Card, Col, Container, Row } from "react-bootstrap";

//layout
import SiteLayout from "src/layouts/SiteLayout";

//components
import StaticBackgroundComponent from "@adjust/website/src/components/StaticBackgroundComponent";
import ParallaxHeaderComponent from "@adjust/website/src/components/ParallaxHeaderComponent";

//locals
import MetaComponent from "./components/MetadataComponent";
import ServiceItemComponent from "./components/ServiceItemComponent";

//images
// import bgImage from "@adjust/public/images/97b9375cf75ade65090bccc8c8ef5884.png";
import bgImage from "@adjust/public/images/5f7cbe2dc628e35784b204b6d16dba89.png";

//data
import services from "./services";
import { css } from "@adjust/website/libs/emotion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const serviceCard = css({
  border: "1px solid #d7e7ff",
  borderRadius: 16,
  height: "100%",
  textAlign: "center",
  transition: ".25s",
});

const icon = css({
  fontSize: 40,
  color: "#1f5fbf",
  marginBottom: 20,
});

const ServiceCard: FunctionComponent<{ title: string; icon: any }> = (service) => {
  return (
    <Card className={serviceCard}>
      <Card.Body>
        <FontAwesomeIcon icon={service.icon} className={icon} />
        <h4>{service.title}</h4>
      </Card.Body>
    </Card>
  );
};

const ServicesPage: NextPage<any> = () => {
  return (
    <SiteLayout>
      <MetaComponent />
      <StaticBackgroundComponent bgImage={bgImage} bgImageAlt="Parallax Image" fetchPriority="high" priority>
        <ParallaxHeaderComponent size="sm">Services We Provide</ParallaxHeaderComponent>
      </StaticBackgroundComponent>
      <Container className="my-5 text-center">
        <h2>Every trip is customized for you.</h2>
        <p className="lead text-muted mx-auto" style={{ maxWidth: 700 }}>
          Whether you're planning a honeymoon, family vacation, luxury cruise, or all-inclusive escape, we'll handle every detail so you can focus on making memories.
        </p>
      </Container>
      <Container className="my-5">
        <Row className="g-4">
          {services.map((service) => (
            <Col xs={12} md={6} lg={4} key={service.title}>
              <ServiceCard {...service} />
            </Col>
          ))}
        </Row>
      </Container>
    </SiteLayout>
  );
};

export default ServicesPage;
